module.exports = __webpack_public_path__ + "img/hyzs.b2553905.png";